import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "core-js/features/array/find";
import "core-js/features/array/includes";
import "core-js/features/object/entries";
import "core-js/features/number/is-nan";

///////////////////////////////////
// For ie11:                     //
//     Element.prototype.matches //
//     Element.prototype.closest //
//     Element.prototype.remove  //
///////////////////////////////////
if (typeof window !== "undefined" && typeof document !== "undefined") {
  // we're in browser
  // tslint:disable-next-line:no-var-requires
  require("dom4"); // only import actual dom4 if we're in the browser (not server-compatible)
  // we'll still need dom4 types for the TypeScript to compile, these are included in package.json
}

/////////////////////////////////////////////////////////////////////
// CODE BELOW DUPLICATES FUNCTIONALITY OF `require("dom4");` ABOVE //
/////////////////////////////////////////////////////////////////////

// //Element.prototype.matches
// (function() {
//   if (!Element.prototype.matches) {
//     // noinspection JSUnresolvedVariable
//     Element.prototype.matches =
//       Element.prototype.msMatchesSelector ||
//       Element.prototype.webkitMatchesSelector;
//   }
// })();

// // Element.prototype.closest
// (function() {
//   if (!Element.prototype.closest) {
//     Element.prototype.closest = function(s) {
//       // noinspection ES6ConvertVarToLetConst
//       var el = this;
//
//       do {
//         if (el.matches(s)) return el;
//         el = el.parentElement || el.parentNode;
//       } while (el !== null && el.nodeType === 1);
//       return null;
//     };
//   }
// })();

// // Element.prototype.remove
// // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
// (function(arr) {
//   arr.forEach(function(item) {
//     if (item.hasOwnProperty("remove")) {
//       return;
//     }
//     Object.defineProperty(item, "remove", {
//       configurable: true,
//       enumerable: true,
//       writable: true,
//       value: function remove() {
//         if (this.parentNode === null) {
//           return;
//         }
//         this.parentNode.removeChild(this);
//       }
//     });
//   });
// })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// // window.CustomEvent
// // window.Event
// (function() {
//   if (typeof window.CustomEvent === "function") return false; //If not IE
//
//   function CustomEvent(event, params) {
//     params = params || { bubbles: false, cancelable: false, detail: undefined };
//     // noinspection ES6ConvertVarToLetConst
//     var evt = document.createEvent("CustomEvent");
//     evt.initCustomEvent(
//       event,
//       params.bubbles,
//       params.cancelable,
//       params.detail
//     );
//     return evt;
//   }
//
//   // noinspection JSValidateTypes
//   CustomEvent.prototype = window.Event.prototype;
//
//   // noinspection JSValidateTypes
//   window.CustomEvent = CustomEvent;
//   window.Event = CustomEvent;
// })();
